export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[720px] flex items-center justify-center overflow-hidden" aria-label="Hero 区域">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20silhouette%20of%20a%20person%20running%20toward%20a%20blazing%20golden%20sunrise%20on%20a%20mountain%20ridge%2C%20vast%20landscape%20with%20warm%20orange%20and%20amber%20sky%2C%20inspiring%20and%20powerful%20atmosphere%2C%20cinematic%20composition%2C%20epic%20scale%2C%20clean%20silhouette%20style&width=1600&height=900&seq=jiuqugan-hero-2026&orientation=landscape"
        alt="就去干 - 行动力觉醒"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center flex flex-col items-center">
        <p className="text-accent-400 text-sm md:text-base font-medium tracking-[0.3em] uppercase mb-4 animate-[fadeInUp_0.6s_ease-out]">
          行动力觉醒
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight mb-6 max-w-4xl animate-[fadeInUp_0.6s_ease-out_0.1s]">
          <span className="block">就去干</span>
          <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-2 text-background-50/80">
            想，都是问题；干，才有答案
          </span>
        </h1>
        <p className="text-background-50/70 text-sm md:text-lg max-w-2xl mb-10 animate-[fadeInUp_0.6s_ease-out_0.2s] leading-relaxed">
          无论面对多大的目标、多深的恐惧，就去干，才是改变命运的唯一起点。本平台帮你激活行动基因，从此告别空想。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 animate-[fadeInUp_0.6s_ease-out_0.3s]">
          <a
            href="#categories"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始行动
            <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="#featured"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full text-sm transition-all duration-300 backdrop-blur-sm whitespace-nowrap cursor-pointer"
          >
            精选文章
            <i className="ri-article-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl w-6 h-6 flex items-center justify-center"></i>
      </div>
    </section>
  );
}